interface Props {
  children: string | any;
  style?: object;
  className?: string;
  ref?: any;
}
const BlockyLightText = (props: Props) => {
  return (
    <div
      {...props}
      style={{
        fontFamily: "Chakra Petch",
        fontWeight: 300,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export default BlockyLightText;
